import { render } from "./SearchLayout.vue?vue&type=template&id=cfa51522&ts=true"
import script from "./SearchLayout.vue?vue&type=script&lang=ts"
export * from "./SearchLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__